import { FN_GRAPH_NODE_try_select_existing_node } from '@/pages/page_generation/layouts/nodes/_watchers/FN_GRAPH_NODE_try_select_existing_node';
import { FN_FIELD_IMAGE__edit__update_field } from '@/pages/page_generation/sidebar/image_asset/_methods/FN_FIELD_IMAGE__edit__update_field';
import { REMOTE__generation_update_graph } from '@/state/generation/settings/REMOTE__generation_update_graph';
import { LOCAL__grid2d_delete } from '@/state/grid2d/grid2d/LOCAL__grid2d_delete';
import { store } from '@/state/store';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';

export class UTILS__graph_data {
  static async update_field<T extends FIELD__base>(graph: DTO_GRAPH__instance, field: T) {
    graph = graph.clone();

    graph.field__replace(field);

    await UTILS__graph_data.update(graph);
  }

  static async update(graph: DTO_GRAPH__instance) {
    let generation = store.getState().slice_generation.generations_map.get_or_assert(graph.meta.graph_id);

    if (generation.status == ENUM__generation_status.ADJUSTING) {
      store.dispatch(LOCAL__grid2d_delete([graph.meta.graph_id]));
    }

    graph.stubify_images();

    graph.hash_clear();

    FN_GRAPH_NODE_try_select_existing_node(graph);

    FN_FIELD_IMAGE__edit__update_field(graph);

    await store.dispatch(REMOTE__generation_update_graph(graph));
  }
}
